import React from 'react';
import { motion } from 'framer-motion';
import LuxuryButton from '../ui/LuxuryButton';
import { Reveal } from '../animations/Reveal';
import {
    FaShoppingBag,
    FaLeaf,
    FaArrowRight,
    FaStar
} from 'react-icons/fa';

const EmptyCart = ({ compact = false }) => {
    return (
        <Reveal>
            <div className={`text-center ${compact ? 'py-6' : 'py-12 sm:py-16'}`}>
                {/* Icon */}
                <motion.div
                    animate={{
                        y: [0, -10, 0],
                        rotate: [0, 5, -5, 0]
                    }}
                    transition={{
                        duration: 4,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="inline-flex items-center justify-center mb-4 sm:mb-6"
                >
                    <div className="relative">
                        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-champagne/10 to-sage/10 flex items-center justify-center">
                            <FaShoppingBag className="w-6 h-6 sm:w-8 sm:h-8 text-charcoal/30" />
                        </div>
                        <div className="absolute -top-2 -right-2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-sage/10 flex items-center justify-center">
                            <FaLeaf className="w-3 h-3 sm:w-4 sm:h-4 text-sage" />
                        </div>
                    </div>
                </motion.div>

                {/* Message */}
                <div className="mb-6 sm:mb-8">
                    <h2 className="text-xl sm:text-2xl font-light text-charcoal mb-2 sm:mb-3">
                        Your Ritual Awaits
                    </h2>
                    <p className="text-sm sm:text-base text-charcoal/60 max-w-md mx-auto leading-relaxed px-4">
                        Your cart is currently empty. Begin your journey to radiant skin with our
                        carefully curated collection of transformative beauty essentials.
                    </p>
                </div>

                {/* CTA */}
                <LuxuryButton
                    variant="primary"
                    size={compact ? 'medium' : 'large'}
                    onClick={() => window.location.href = '/shop'}
                    icon={FaArrowRight}
                    iconPosition="right"
                    className="group"
                >
                    <span className="flex items-center gap-2 text-sm sm:text-base">
                        <FaStar className="w-3 h-3 sm:w-4 sm:h-4" />
                        Explore Collection
                    </span>
                </LuxuryButton>

                {/* Featured Categories - Desktop only */}
                {!compact && (
                    <Reveal delay={0.3}>
                        <div className="mt-8 sm:mt-12 pt-8 sm:pt-12 border-t border-nude/30">
                            <p className="text-xs sm:text-sm text-charcoal/40 mb-3 sm:mb-4">Popular Categories</p>
                            <div className="flex flex-wrap justify-center gap-2 sm:gap-3 px-4">
                                {['Serums', 'Moisturizers', 'Cleansers', 'Face Oils', 'Gift Sets'].map((category, index) => (
                                    <motion.button
                                        key={category}
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                        whileHover={{ scale: 1.05 }}
                                        className="px-3 py-1.5 sm:px-4 sm:py-2 bg-white border border-nude rounded-xl text-xs sm:text-sm text-charcoal/70 hover:border-champagne hover:text-champagne transition-colors"
                                    >
                                        {category}
                                    </motion.button>
                                ))}
                            </div>
                        </div>
                    </Reveal>
                )}
            </div>
        </Reveal>
    );
};

export default EmptyCart;